export const TASK_CONFIGS = {
  bulkCapeAnalyticsRoofAgeReport: {
    columnOrder: ['Policy Id', 'Roof Year', 'Cape Roof Year', 'Cape Roof Year Confidence Score', 'Coverage Type']
  },
  // Agency production report send (#36517): who/what first, then the outcome.
  toolsSendAgencyProductionReports: {
    columnOrder: ['status', 'email', 'agency_stem', 'report_month', 'sent_to', 'attachment', 'sent_at', 'error']
  }
};

export const getTaskConfig = (taskName) => {
  return TASK_CONFIGS[taskName] || null;
};
